import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import appConfig from 'app-config';
import { getBrand } from 'flow/brands/brands';
import { List } from 'immutable';
import Spokes from 'resources/headsets/spokes';
import epossdk from 'resources/headsets/epos/epossdk.v1';
import { electronActions } from 'flow/utils/electron-utils';
import { addHeadsetLogEntry } from 'flow/utils/browser-utils';
var HeadsetPoller = /*#__PURE__*/function () {
  function HeadsetPoller() {
    _classCallCheck(this, HeadsetPoller);
  }
  return _createClass(HeadsetPoller, [{
    key: "poll",
    value: function poll() {
      return Promise.resolve();
    }
  }]);
}();
var Jabra4Poller = /*#__PURE__*/function (_HeadsetPoller) {
  function Jabra4Poller() {
    _classCallCheck(this, Jabra4Poller);
    return _callSuper(this, Jabra4Poller, arguments);
  }
  _inherits(Jabra4Poller, _HeadsetPoller);
  return _createClass(Jabra4Poller, [{
    key: "poll",
    value: function () {
      var _poll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return electronActions.initJabra();
            case 1:
              return _context.abrupt("return", _context.sent);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function poll() {
        return _poll.apply(this, arguments);
      }
      return poll;
    }()
  }]);
}(HeadsetPoller);
var PlantronicsPoller = /*#__PURE__*/function (_HeadsetPoller2) {
  function PlantronicsPoller() {
    _classCallCheck(this, PlantronicsPoller);
    return _callSuper(this, PlantronicsPoller, arguments);
  }
  _inherits(PlantronicsPoller, _HeadsetPoller2);
  return _createClass(PlantronicsPoller, [{
    key: "poll",
    value: function poll() {
      return new Promise(function (resolve) {
        Spokes.Device.deviceInfo(function (result) {
          if (!result.isError && result.Result !== null) {
            resolve(result.Result);
          } else {
            resolve();
          }
        });
      });
    }
  }]);
}(HeadsetPoller);
var EPOSPoller = /*#__PURE__*/function (_HeadsetPoller3) {
  function EPOSPoller() {
    _classCallCheck(this, EPOSPoller);
    return _callSuper(this, EPOSPoller, arguments);
  }
  _inherits(EPOSPoller, _HeadsetPoller3);
  return _createClass(EPOSPoller, [{
    key: "poll",
    value: function poll() {
      return new Promise(function (resolve) {
        var logger = function logger(log) {
          return addHeadsetLogEntry('[EPOS] ' + log);
        };
        var brandName = getBrand().brandNameUIFriendly;
        var sdk = new epossdk(brandName, brandName, appConfig.version, -1, logger);
        var deviceInfo = {
          sdk: sdk,
          ManufacturerName: 'EPOS'
        };
        var timeoutId = setTimeout(function () {
          sdk.removeAllListeners();
          sdk.SendTerminateEvent();
          resolve();
        }, 5000);
        sdk.on('LoginStatusChanged', function (status) {
          if (status === 'EstablishConnection') {
            sdk.once('HeadsetConnected', function () {
              clearTimeout(timeoutId);
              sdk.removeAllListeners();
              resolve(deviceInfo);
            });
            sdk.SendLoginEvent();
          }
        });
      });
    }
  }]);
}(HeadsetPoller);
var YealinkPoller = /*#__PURE__*/function (_HeadsetPoller4) {
  function YealinkPoller() {
    _classCallCheck(this, YealinkPoller);
    return _callSuper(this, YealinkPoller, arguments);
  }
  _inherits(YealinkPoller, _HeadsetPoller4);
  return _createClass(YealinkPoller, [{
    key: "poll",
    value: function () {
      var _poll2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve) {
                electronActions.initYealink().then(function (deviceId) {
                  if (deviceId) {
                    resolve({
                      ManufacturerName: 'Yealink',
                      deviceId: deviceId
                    });
                  } else {
                    resolve();
                  }
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function poll() {
        return _poll2.apply(this, arguments);
      }
      return poll;
    }()
  }]);
}(HeadsetPoller);
var jabra4Poller = new Jabra4Poller();
var plantronicsPoller = new PlantronicsPoller();
var eposPoller = new EPOSPoller();
var yealinkPoller = new YealinkPoller();
export var getHeadsetPollers = function getHeadsetPollers() {
  return List([jabra4Poller, plantronicsPoller, eposPoller, yealinkPoller]);
};